export default __webpack_public_path__ + "static/depoimento-2-78a9d46eb2a19c687fff4e479948e335.svg";